import React, { useState } from "react";
import { register } from "../../services/auth";
import "./style.scss";
export default function Register() {
  let [name, setName] = useState("");
  let [email, setEmail] = useState("");
  let [password, setPassword] = useState("");
  return (
    <div className="register-container">
      <h1 className="register-title">Register</h1>
      <input
        placeholder="name"
        onKeyUp={(e) => setName(e.target.value)}
        id="r_name"
      />
      <input
        placeholder="email"
        onKeyUp={(e) => setEmail(e.target.value)}
        id="r_email"
      />
      <input
        placeholder="password"
        type={"passord"}
        onKeyUp={(e) => setPassword(e.target.value)}
        id="r_password"
      />
      <button
        onClick={(e) => {
          e.preventDefault();
          register({
            name,
            email,
            password,
          });
        }}>
        Register
      </button>
    </div>
  );
}
